import Vue from 'vue'
import { lang } from '@public/utils/filters'
import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'
dayjs.extend(isoWeek)
const msgVue = new Vue()

// 图片校验正则
export const imgRegular = /\.(jpe?g|png|gif)/i
// Base64图片校验正则
export const imgRegularBase = /(^data\:image\/)|(\.(jpe?g|png|gif))/i
/* 防抖
callback: 回调函数
time: 过滤时间 毫秒
*/
export const debounceFn = () => {
  let timeoutObj
  return (callback, time, val) => {
    clearTimeout(timeoutObj)
    timeoutObj = setTimeout(() => {
      callback(val)
    }, time);
  }
}
// 单个可直接使用 debounce
export const debounce = debounceFn()

/* 节流
callback: 回调函数
time: 过滤时间 毫秒
*/
export const throttle = (callback, time) => {
  let stop = false
  return () => {
    !stop && callback()
    stop = true
    setTimeout(() => {
      stop = false
    }, time);
  }
}

/* 拷贝文字
text: 拷贝内容
hide: 是否隐藏提示
*/
export const copyText = (text, hide) => {
  const input = document.createElement('textarea') // 换成textarea可换行
  input.style.position = 'fixed'
  input.style.top = '-1000px'
  document.body.append(input)
  input.value = text
  input.select()
  document.execCommand('copy')
  document.body.removeChild(input)
  !hide && msgVue.$message.success(lang('复制成功'))
}
/*
 *@Description: 复制文本到剪切板
*/
export const customCopyText = txt => {
  if (typeof txt !== 'string' || !txt.length) {
    return
  }
  let txtEl = document.createElement('input')
  txtEl.setAttribute('type', 'text')
  txtEl.setAttribute('value', txt)
  txtEl.style.position = 'fixed'
  txtEl.style.left = '-999999px'
  txtEl.style.top = '-9999px'
  document.body.appendChild(txtEl)
  txtEl.select()
  document.execCommand('copy')
  document.body.removeChild(txtEl)
  txtEl = null
}
/*
 *@Description: 数组对象去重
*/
export const removeRepeat = (arr) => {
  if (typeof arr[0] === 'object') {
    for (let i = 0; i < arr.length; i++) {
      arr[i] = JSON.stringify(arr[i])
    }
    arr = [...new Set(arr)]
    for (let i = 0; i < arr.length; i++) {
      arr[i] = JSON.parse(arr[i])
    }
  } else {
    arr = [...new Set(arr)]
  }
  return arr
}
// 图片校验返回icon
export const imgRegularFn = (fileJson) => {
  return fileJson.map((url, key) => {
    let icon = ''
    if (Object.prototype.toString.call(url) === '[object Object]') url = url.url
    if (~url.indexOf('.pdf')) {
      icon = 'iconPDF'
    } else if (~url.indexOf('.docx')) {
      icon = 'icondocx1'
    } else if (~url.indexOf('.doc')) {
      icon = 'icondoc1'
    } else if (~url.indexOf('.zip')) {
      icon = 'iconyasuobao'
    } else if (~url.indexOf('.rar')) {
      icon = 'iconRAR'
    } else if (!url.match(/\.(jpe?g|png|gif)/i)) {
      icon = 'icongonggaoguanli-wendang'
    }
    return {
      id: key,
      icon,
      url
    }
  })
}

export const isEmptyObject = (obj) => Object.keys(obj).length === 0 && obj.constructor === Object;
// 非空对象
export const isEmptyObj = (obj) => Object.keys(obj).length === 0 && obj.constructor === Object;

// 删除空对象 删除'', null, undefined
export const isRemoveEmpty = (obj) => {
  const _newPar = {}
  for (const key in obj) {
    // 如果对象属性的值不为空，就保存该属性（这里我做了限制，如果属性的值为0，保存该属性。如果属性的值全部是空格，属于为空。）
    if ((obj[key] === 0 || obj[key]) && obj[key].toString().replace(/(^\s*)|(\s*$)/g, '') !== '') {
      // 记录属性
      _newPar[key] = obj[key]
    }
  }
  // 返回对象
  return _newPar
}

export const getImgSrcObj = (str) => {
  const srcArr = []
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = str
  // 查找所有的img元素
  const imgElements = tempDiv.getElementsByTagName('img')
  // 遍历每个img元素，提取src属性值
  if (imgElements.length) {
    for (let i = 0; i < imgElements.length; i++) {
      const imageUrl = imgElements[i]?.getAttribute('src')
      if (!imageUrl?.includes('http')) {
        srcArr.push(imageUrl)
      }
    }
  }
  return {
    html: str,
    srcArr
  }
}

// 消息表情包替换
export const replaceEmoji = (str) => {
  let nStr = str
  try {
    if (str) {
      nStr = str.replace(/#E-s(\d{2})/g, (match, p1) => {
        const imgSrc = require('@/assets/images/emoticon/s' + p1 + '.png')
        return `<img class="em-icon" src="${imgSrc}" alt=""/>`;
      })
    }
  } catch (e) {
    console.log(e)
  }
  return nStr
}
// 判断两个数组是否有重复的值
export const haveDuplicateValues = (arr1, arr2) => {
  const set = new Set(arr1)
  for (let i = 0; i < arr2.length; i++) {
    if (set.has(arr2[i])) {
      return true
    }
  }
  return false
}
// 获取时间是今年的第几周  1月1日为第一周  默认传参为年尾
export const getWeekNum = (dayTime = dayjs().endOf('year')) => {
  if (!dayjs(dayTime).isValid()) return
  // 获得当前日期是第几周的方法
  const year = new Date().getFullYear();// 获得今年
  const week = dayjs(dayTime).day() || 7;// 获得今天是星期几
  const startweek = new Date(year + '-01-01').getDay() || 7// 获得今年的1月1号是星期几
  // 今天到1月1号的时间戳之差
  const millisDiff =
    new Date(dayjs(dayTime).format('YYYY-MM-DD')).getTime() -
    new Date(year + '-01-01').getTime()
  // （今天到1月1号的时间戳之差-本周之前的天数-1月1日之后的天数）/7 + 本周与1月1日周
  const days =
    (millisDiff -
      week * (24 * 60 * 60 * 1000) -
      (7 - startweek) * (24 * 60 * 60 * 1000)) /
      (24 * 60 * 60 * 1000)
  return days / 7 + 2
  // 这里加的2代表的是本周和今年1月1号所在的那一周
}

// 获取周一与周日  dayTime--传入时间  默认传参为当前时间
export const weekCheckingIn = (dayTime = new Date()) => {
  var nowTime = new Date(dayTime).getTime() ;
  var day = new Date(dayTime).getDay() || 7;// 不加 || 7.周末会变成下周一
  var oneDayTime = 24 * 60 * 60 * 1000 ;
  var MondayTime = nowTime - (day - 1) * oneDayTime ;// 显示周一
  var SundayTime = nowTime + (7 - day) * oneDayTime ;// 显示周日
  return [dayjs(MondayTime).format('YYYY-MM-DD'), dayjs(SundayTime).format('YYYY-MM-DD')]
}
// 正则表达式将数字的千位之间添加逗号分隔符
export const addSeparatorToNumber = (number) => {
  if (number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else if (number === 0) {
    return number + ''
  }
}


// 获取当前周为第几周
export function currentWeekOfYear(date) {
  const currentWeek = dayjs(date).isoWeek()
  return currentWeek
}
// 获取一年有多少周
export function getYearWeekCount(year) {
  // ISO 规则：12 月 28 日一定属于当年的最后一周
  return dayjs(`${year}-12-28`).isoWeek()
}